<template>
  <section>
    <div class="main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <h1 class="title">Analyst Hub’s Apps</h1>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/dax.svg" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/dax-logo.svg" alt="" width="85" />
                <p>Cleanup and format your DAX code.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Dax' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/m-code.svg" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/m_logo.svg" alt="" width="85" />
                <p>Paste, Save and Edit your own M Code formulas.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'M Code' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/r-code.svg" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/r_logo.svg" alt="" width="85" />
                <p>Paste, Save and Edit your own Code in any language.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'RAW Code' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <!-- new -->
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/python-code-thumbnail.svg" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/python-code-logo.svg" alt="" width="85" />
                <p>Paste, Save and Edit your own Python code.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'PythonCode' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/rcode-code-thumbnail.svg" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/r-code-logo.svg" alt="" width="85" />
                <p>Paste, Save and Edit your own R code.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'RCode' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/notepad-code-thumbnail.svg" alt="" />
              </div>
              <div class="app-card-info">
                <img
                  src="/assets/img/notepad-code-logo.svg"
                  alt=""
                  width="85"
                />
                <p>Notepad - Quickly create notes for sharing.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Notepad' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <!-- new -->

          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/App-card-Picture3.jpg" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/colors-logo.svg" alt="" width="85" />
                <p>
                  Create beautiful Colour Themes, with Enterprise DNA's palette
                  generators.
                </p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Colour generator' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img
                  src="/assets/img/power_bi_theme_thumb.svg"
                  alt="Power BI Themes generator thumbnail"
                />
              </div>
              <div class="app-card-info">
                <img
                  src="/assets/img/power_bi_theme_icon.svg"
                  alt="Power BI Themes generator icon"
                  height="33"
                />
                <p>Create Power BI custom themes.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'PowerBiThemes' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/portfolio-app.png" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/portfolio-logo.svg" alt="" width="85" />
                <p>
                  Share Pictures and Links with your team or the Analyst Hub
                  Community.
                </p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Project Share' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/planner-app.png" alt="" />
              </div>
              <div class="app-card-info">
                <img src="/assets/img/planner-logo.svg" alt="" width="85" />
                <p>Plan your analytics workload within the Analyst Hub.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Analytics Planner' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/priority-app.png" alt="" />
              </div>
              <div class="app-card-info">
                <img
                  src="/assets/img/priorities-matrix.svg"
                  alt=""
                  width="85"
                />
                <p>Define priorities for you and your team.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Priorities Matrix' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img
                  src="/assets/img/model_planner_thumb.svg"
                  alt="Data model planner thumbnail"
                />
              </div>
              <div class="app-card-info">
                <img
                  src="/assets/img/model_planner_icon.svg"
                  alt="Data model planner icon"
                  height="33"
                />
                <p>Plan your data model workload within the Analyst Hub.</p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Data Model Planner' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img
                  src="/assets/img/pipeline_planner_thumb.svg"
                  alt="Data pipeline planner thumbnail"
                />
              </div>
              <div class="app-card-info">
                <img
                  src="/assets/img/pipeline_planner_icon.svg"
                  alt="Data pipeline planner icon"
                  height="33"
                />
                <p>
                  Improve your workflow and plan your Power BI data pipeline
                  with your team.
                </p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Data Pipeline Planner' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">
            <div class="app-card-box">
              <div class="app-card-image">
                <img src="/assets/img/playlist_play.svg" alt="Playlist app" />
              </div>
              <div class="app-card-info">
                <img
                  src="/assets/img/playlist-icon.svg"
                  alt="Data pipeline planner icon"
                  height="33"
                />
                <p>
                  Create a playlist of Youtube videos and share it with anyone.
                </p>
                <router-link
                  @click.native="scrollToTop"
                  :to="{ name: 'Playlist' }"
                  class="btn btn-sm-primary"
                  >Use App</router-link
                >
              </div>
            </div>
          </div>
<!--          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">-->
<!--            <div class="app-card-box">-->
<!--              <div class="app-card-image">-->
<!--                <img src="/assets/img/App-card-Picture2.jpg" alt="" />-->
<!--              </div>-->
<!--              <div class="app-card-info">-->
<!--                <img src="/assets/img/edna-logo.svg" alt="" width="85" />-->
<!--                <p>-->
<!--                  The Enterprise DNA's chat bot, for your Power BI and DAX-->
<!--                  queries.-->
<!--                </p>-->
<!--                <router-link-->
<!--                  @click.native="scrollToTop"-->
<!--                  :to="{ name: 'EDNA Bot' }"-->
<!--                  class="btn btn-sm-primary"-->
<!--                  >Use App</router-link-->
<!--                >-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-12 col-xl-4 col-lg-6 col-md-6 col-sm-6 mb-4">-->
<!--            <div class="app-card-box">-->
<!--              <div class="app-card-image">-->
<!--                <img src="/assets/img/App-card-Picture4.jpg" alt="" />-->
<!--              </div>-->
<!--              <div class="app-card-info">-->
<!--                <img src="/assets/img/knowledge-logo.svg" alt="" width="85" />-->
<!--                <p>-->
<!--                  Discover important Power BI tips & techniques as well as DAX-->
<!--                  Formulas.-->
<!--                </p>-->
<!--                <a-->
<!--                  href="https://info.enterprisedna.co"-->
<!--                  target="_blank"-->
<!--                  class="btn btn-sm-primary"-->
<!--                  >Use App</a-->
<!--                >-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    const titleEl = document.querySelector("head title");
    titleEl.textContent = "Analyst Hub by Enterprise DNA";
  },
};
</script>
<style>
</style>
